import { render, staticRenderFns } from "./index.vue?vue&type=template&id=5c52c21b&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=5c52c21b&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c52c21b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/godata/pipelines/eShop-Portal-Web-Release-Prod/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c52c21b')) {
      api.createRecord('5c52c21b', component.options)
    } else {
      api.reload('5c52c21b', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=5c52c21b&scoped=true", function () {
      api.rerender('5c52c21b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/financialcenter/applyBilling/index.vue"
export default component.exports